import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { PayoffRequestStore } from './../stores/payoffRequestStore';

export const usePayoffRequestStore = () => useContext<{
  payoffRequestStore: PayoffRequestStore
}>(StoreContext);
